<template>
  <div>
    <CRow>
      <CCol sm="6" md="8">
        <CCard>
          <CCardHeader>
            Payment Method
          </CCardHeader>
          <CCardBody>
                    <div class="panel-body" id="app">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th>Bank</th>
                                <th>Account</th>
                                <th>Description</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody v-sortable.tr="rows">
                      
                            <tr v-for="(arr, index) in form.value" :key="index">
                                <td>
                                    <input class="form-control" v-model="arr.bank"/>
                                </td>
                                <td>
                                    <input class="form-control" v-model="arr.account"/>
                                </td>
                                <td>
                                    <input class="form-control" v-model="arr.description"/>
                                </td>
                                <td>
                                    <CButton  color="info" block size="sm" variant="outline" @click="addRow(index)">Add </CButton>
                                    <CButton  color="danger" block  size="sm" variant="outline" @click="removeRow(index)">Remove</CButton>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <CButton type="submit" v-on:click.prevent="save()"  variant="outline" color="info">Save</CButton>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
      
    <CRow>
      <CCol sm="6" md="8">
        <CCard>
          <CCardHeader>
            Apps BG Image Setting
          </CCardHeader>
          <CCardBody>
            <CButton  class="ml-3" color="info" @click="openModalPhoto('home_bgimage')"><b>Home BG Image</b></CButton>
            <CButton  class="ml-3" color="info" @click="openModalPhoto('event_bgimage')"><b>Event BG Image</b></CButton>
            <CButton  class="ml-3" color="info" @click="openModalPhoto('location_bgimage')"><b>Location BG Image</b></CButton>
            <CButton  class="ml-3" color="info" @click="openModalPhoto('profile_bgimage')"><b>Profile BG Image</b></CButton>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="8">
        <CCard>
          <CCardHeader>
            Apps Settings - Join ICare Page
          </CCardHeader>
          <CCardBody>
            <!-- <CRow>
              <CCol>
                <b> Email List to receive information (multiple email separate with comma)</b>
              </CCol> 
            </CRow> -->
            <CRow>
              <CCol sm="8">
                <!-- <input class="form-control" v-model="form_email_office.value"/> -->
                <CInput
                  label="Email List to receive information"
                  description="multiple email separate with comma"
                  placeholder=""
                  type="email"
                  horizontal
                  autocomplete="email"
                  v-model="form_email_office.value"
                />
              </CCol>
              <CCol sm="2">
                <CButton type="submit" v-on:click.prevent="save_email_office()"  variant="outline" color="info">Save</CButton>
              </CCol>  
            </CRow>
            <hr>
            <CRow>
              <CCol sm="8">
                <!-- <input class="form-control" v-model="form_icarerequest_description.value"/> -->
                <CTextarea
                  label="Description"
                  placeholder=""
                  horizontal
                  rows="5"
                  v-model="form_icarerequest_description.value"
                />
              </CCol>
              <CCol sm="2">
                <CButton type="submit" v-on:click.prevent="save_icarerequest_description()"  variant="outline" color="info">Save</CButton>
              </CCol>  
            </CRow>
            <hr>
            <CRow>
              <CCol sm="8">
                <CButton  label="asd" class="ml-3" color="info" @click="openModalPhoto('icarerequest_bgimage')"><b>ICare Request BG Image</b></CButton>
              </CCol> 
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="8">
        <CCard>
          <CCardHeader>
            Apps Settings - Default CSS Discover Webview
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="8">
                <CTextarea
                  placeholder=""
                  horizontal
                  rows="5"
                  v-model="form_css_discover.value"
                />
              </CCol>
              <CCol sm="2">
                <CButton type="submit" v-on:click.prevent="save_css_discover()"  variant="outline" color="info">Save</CButton>
              </CCol>  
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="8">
        <CCard>
          <CCardHeader>
            Apps Settings - Class Module
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="8">
                <label>List Text Color Class Template</label> <div :style="{backgroundColor: form_class_textcolor_list_setting.value }">current color {{ form_class_textcolor_list_setting.value }}</div> 
                <!-- <CButton class="btn btn-sm" type="button" @click="clear('Back Button Text Color')"  variant="outline" color="info">clear</CButton> -->
                <br>
                <colorpicker :color="form_class_textcolor_list_setting.value" v-model="form_class_textcolor_list_setting.value"/>
                <br>
              </CCol>
              <CCol sm="8">
                <label>List Color Class Template</label> <div :style="{backgroundColor: form_class_color_list_setting.value }">current color {{ form_class_color_list_setting.value }}</div> 
                <!-- <CButton class="btn btn-sm" type="button" @click="clear('Back Button Text Color')"  variant="outline" color="info">clear</CButton> -->
                <br>
                <colorpicker :color="form_class_color_list_setting.value" v-model="form_class_color_list_setting.value"/>
                <br>
              </CCol>
              <CCol sm="2">
                <CButton type="submit" v-on:click.prevent="save_class_setting()"  variant="outline" color="info">Save</CButton>
              </CCol>  
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
<!-- <pre>{{ $data }}</pre> -->
<alertmodal></alertmodal>
<modalphoto></modalphoto>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';
import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

import setting from '@/services/setting';
import modalphoto from './modal_photo.vue';

export default {
  components: {
    alertmodal,modalphoto
  },

    data(){
        return{
          form:{
            key: '',
            value:[
              {bank: "", account: "", description: ""}
            ]
          },
          form_email_office:{
            key: '',
            value:''
          },      
          form_icarerequest_description:{
            key: '',
            value:''
          },  
          form_css_discover:{
            key: '',
            value:''
          },    
          form_class_color_list_setting:{
            key: '',
            value:''
          }, 
          form_class_textcolor_list_setting:{
            key: '',
            value:''
          },   
        }
    },
    mounted() {
      this.loadData()
    },
    computed: {
        

    },
    methods: {
      loadData(){
        setting.getSetting("paymentmethod")
        .then(res => {
          this.form.value = JSON.parse(res.data.value);
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })  

        setting.getSetting("email_office")
        .then(res => {
          this.form_email_office.value = res.data.value;
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }) 

        setting.getSetting("default_css_discover")
        .then(res => {
          this.form_css_discover.value = res.data.value;
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }) 

        setting.getSetting("class_template_color")
        .then(res => {
          this.form_class_color_list_setting.value = res.data.value;
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }) 

        setting.getSetting("class_template_textcolor")
        .then(res => {
          this.form_class_textcolor_list_setting.value = res.data.value;
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }) 

      }, 
      save(){
          this.form.key = "paymentmethod"
          //this.form.value = JSON.stringify(this.form.value)
          setting.saveSetting(this.form)
          .then(res => {
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      },
      save_email_office(){
          this.form_email_office.key = "email_office"
          //this.form.value = JSON.stringify(this.form.value)
          setting.saveSetting(this.form_email_office)
          .then(res => {
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      },
      save_icarerequest_description(){
          this.form_icarerequest_description.key = "icarerequest_description"
          //this.form.value = JSON.stringify(this.form.value)
          setting.saveSetting(this.form_icarerequest_description)
          .then(res => {
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      },
      save_css_discover(){
          this.form_css_discover.key = "default_css_discover"
          //this.form.value = JSON.stringify(this.form.value)
          setting.saveSetting(this.form_css_discover)
          .then(res => {
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      },
      save_class_setting(){
          this.form_class_color_list_setting.key = "class_template_color"
          this.form_class_textcolor_list_setting.key = "class_template_textcolor"
          //this.form.value = JSON.stringify(this.form.value)
          setting.saveSetting(this.form_class_color_list_setting)
          .then(res => {
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          })

          setting.saveSetting(this.form_class_textcolor_list_setting)
          .then(res => {
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          })          
      },
      addRow: function (index) {
          try {
              this.form.value.splice(index + 1, 0, {});
          } catch(e)
          {
              console.log(e);
          }
      },
      removeRow: function (index) {
          this.form.value.splice(index, 1);
      },
      openModalPhoto(key){
          if(key === 'home_bgimage'){var title = 'Home Page'}
          if(key === 'event_bgimage'){var title = 'Event Page'}
          if(key === 'location_bgimage'){var title = 'Location Page'}
          if(key === 'profile_bgimage'){var title = 'Profile Page'}
          if(key === 'icarerequest_bgimage'){var title = 'ICare Request Page'}
          var params = {title: 'Global Image | '+title, mode:'edit', data:key}
          EventBus.$emit('OPEN_MODAL_PHOTO', params)
          console.log('load modal photo') 
      },
    }
}
</script>
